<template>
  <div>
    <el-table
      height="450"
      :data="uploadLists"
      class="upload_table"
      ref="table"
      style="width:100%"
    >
      <template slot="empty">
        <div class="emptyTemplate">
          <div>
            <img src="@/assets/img/printingPage/empty.png" alt="" />
            <span>暂无文件</span>
          </div>
        </div>
      </template>
      <el-table-column class="name" prop="name" label="文件名" min-width="40%">
        <template slot-scope="scope">
          <el-popover
            placement="right"
            trigger="hover"
            :content="scope.row.name"
          >
            <p slot="reference" class="fileNameOver">
              {{ scope.row.name }}
            </p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="size" min-width="40%" label="大小">
        <template slot-scope="scope">
          <div
            class="progress"
            v-if="
              scope.row.percentage !== 100 && scope.row.status !== 'success'
            "
          >
            <el-progress
              :percentage="Math.ceil(scope.row.percentage)"
              :format="formatText"
            ></el-progress>
          </div>
          <p
            class="errorP"
            v-else-if="scope.row.response && scope.row.response.code !== 0"
          >
            <i class="el-icon-error"></i>
            <span>{{ scope.row.response.msg }}</span>
          </p>
          <p v-else>{{ scope.row.size | bytesToSize }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="操作" min-width="20%">
        <template slot-scope="scope">
          <ul class="optUl">
            <li>
              <el-popover
                v-if="
                  scope.row.response &&
                    scope.row.response.data &&
                    scope.row.response.data.printNo
                "
                popper-class="optPopover"
                placement="top"
                trigger="hover"
                content="预览文件"
              >
                <div
                  slot="reference"
                  class="itemLi"
                  @click="preview(scope.row)"
                >
                  <div class="fileSearch_img"></div>
                </div>
              </el-popover>
            </li>
            <li>
              <el-popover
                popper-class="optPopover"
                placement="top"
                trigger="hover"
                content="删除文件"
              >
                <div slot="reference" class="itemLi" @click="cancel(scope.row)">
                  <div class="del_img"></div>
                </div>
              </el-popover>
            </li>
          </ul>
        </template>
      </el-table-column>
    </el-table>
    <div class="btnBox">
      <div v-if="printable > 0" @click="confirmPrinting" class="printBtn">
        开始打印
      </div>
      <div v-else class="printBtn disabled">
        开始打印
      </div>
      <div class="cancelBtn" @click="batchCancel">取消</div>
    </div>
    <el-dialog
      title="生成中"
      class="previewDialog"
      :visible.sync="previewDialog"
      width="400px"
      @closed="closePreview"
      destroy-on-close
    >
      <div
        class="uploadProgress"
        v-if="
          currentStatus &&
            (currentStatus.status === 5 || currentStatus.status === 4)
        "
      >
        <div class="icon" style="background-color: transparent">
          <i class="el-icon-error" />
        </div>
        <span class="fileName">{{ currentFile.name }}</span>
        <p>生成打印预览失败</p>
      </div>
      <div v-else-if="currentFile" class="uploadProgress">
        <div class="icon">
          <img src="@/assets/img/printing/production.png" alt="生成中" />
        </div>
        <span class="fileName">{{ currentFile.name }}</span>
        <p>正在生成打印预览</p>
        <el-progress
          color="#1a4bff"
          :percentage="percentage"
          :show-text="false"
          status="exception"
        ></el-progress>
      </div>
    </el-dialog>
    <el-dialog
      title="文件预览"
      class="previewDialog modalIndex"
      :visible.sync="PDFviewer"
      width="400px"
      @closed="closePreviewDialog"
    >
      <div class="previewBox">
        <readOnlyPdfViewer
          class="editFrame"
          v-if="downloadUrl"
          @getPageIndex="_getPageIndex"
          @getPageWordType="getPageWordType"
          :fileUrl="downloadUrl"
          fileType=""
          ref="viewer"
        />
        <div class="pagination">
          {{
            pageCount && currentIndex
              ? `${currentIndex} / ${pageCount}`
              : "页码获取中"
          }}
          <div class="functionBar">
            <i class="enlarge" @click="enlargeFn"></i>
            <i class="narrow" @click="narrowFn"></i>
          </div>
        </div>
        <div @click="PDFviewer = false" class="closePreviewDialog">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { generalPopupInstance } from "common/components/web/generalPopup/generalPopup";
import { cancelPrintDocConvert, fileQuery, getDownUrl } from "api/api";
import readOnlyPdfViewer from "common/components/web/readOnlyPdfViewer/readOnlyPdfViewer";

export default {
  data() {
    return {
      percentage: 0,
      previewDialog: false,
      currentFile: null, // 当前文件
      currentStatus: null, // 当前文件状态
      PDFviewer: false, // 云编辑底层预览
      downloadUrl: null, //下载地址用于预览
      pageCount: "", // 总页数
      currentIndex: "", // 当前页
      printable: 0
    };
  },
  components: {
    readOnlyPdfViewer
  },
  watch: {
    uploadLists: {
      handler(n) {
        if (!n) return 0;
        this.printable = n.filter(
          item => item.response && item.response.code === 0
        ).length;
      },
      deep: true
    }
  },
  props: {
    uploadLists: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    ...mapMutations("batch", ["SET_UPLOAD_LISTS", "SET_IS_UPLOADING"]),
    formatText(e) {
      return "正在上传";
    },
    cancel(row) {
      if (row.response && row.response.data && row.response.data.printNo) {
        // 调用取消打印接口
        cancelPrintDocConvert({ printNo: row.response.data.printNo });
      } else {
        this.$emit("removeFile", row.uid);
      }
      const index = this.uploadLists.findIndex(item => item.uid === row.uid);
      this.uploadLists.splice(index, 1);
      this.SET_UPLOAD_LISTS(this.uploadLists);
    },
    batchCancel() {
      if (this.printable > 0) {
        const generalPopup = generalPopupInstance({
          icon: "warningIcon",
          title: "提示",
          message: `文件还未打印，确定要全部取消吗？`,
          beforeClose: (action, done) => {
            if (action === "confirm") {
              const loading = this.$loading();
              const printableLists = this.uploadLists.filter(
                ({ response }) => response && response.code === 0
              );
              Promise.all(
                printableLists.map(item => this.cancelItem(item))
              ).finally(() => {
                this.SET_UPLOAD_LISTS([]);
                this.SET_IS_UPLOADING(false);
                loading.close();
              });
              done();
              generalPopup.destory();
            } else {
              done();
              generalPopup.destory();
            }
          }
        });
      } else {
        // 无可打印文件无需发请求 直接清空列表
        this.SET_UPLOAD_LISTS([]);
        this.SET_IS_UPLOADING(false);
      }
    },
    cancelItem(row) {
      return new Promise(resolve => {
        if (row.response && row.response.data && row.response.data.printNo) {
          // 调用取消打印接口
          cancelPrintDocConvert({ printNo: row.response.data.printNo })
            .then(() => {
              resolve();
            })
            .catch(() => {
              resolve();
            });
        } else {
          this.$emit("removeFile", row.uid);
          resolve();
        }
      });
    },
    preview(row) {
      this.percentage = 0;
      this.currentFile = row;
      this.previewDialog = true;
      const callback = downloadURL => {
        this.previewDialog = false;
        this.downloadUrl = downloadURL;
        this.PDFviewer = true;
      };
      this.searchStatus(callback);
      this.fakePercentage();
    },
    // 查询转换状态
    searchStatus(callback) {
      this.statusTimer = setTimeout(() => {
        if (this.currentFile && !this.isClearTimer) {
          const printNo = this.currentFile.response.data.printNo;
          fileQuery(printNo).then(({ data }) => {
            this.currentStatus = data;
            if (data.status !== 5 && data.status !== 6) {
              this.searchStatus(callback);
            } else {
              if (data.status === 6) {
                // todo targetDocId 塞进列表内
                if (this.previewDialog) {
                  // 判断是否被手动关闭了
                  setTimeout(() => {
                    //获取下载地址用于预览
                    this.getDownUrlFn(printNo, callback);
                  }, 500);
                }
              }
              clearTimeout(this.statusTimer);
            }
          });
        }
      }, 1500);
    },
    // 获取下载地址
    getDownUrlFn(printNo, callback) {
      getDownUrl({ printNo: printNo })
        .then(res => {
          const { code, data } = res;
          if (code === 0) {
            callback && callback(data.downloadURL);
          }
        })
        .catch({});
    },
    fakePercentage() {
      this.percentageTimer = setTimeout(() => {
        if (this.currentStatus && this.currentStatus.status === 6) {
          return (this.percentage = 100);
        }
        if (
          this.currentStatus &&
          (this.currentStatus.status === 5 || this.currentStatus.status === 4)
        )
          return; // 失败返回
        const step = Math.ceil(Math.random() * 10);
        const total = (this.percentage += step);
        if (total > 99) this.percentage = 99;
        this.fakePercentage();
      }, 1000);
    },
    closePreview() {
      this.currentFile = null;
      this.currentStatus = null;
    },
    closePreviewDialog() {
      this.downloadUrl = null;
      this.pageCount = null;
      this.currentIndex = null;
    },
    // 获取是否有密码
    getPageWordType(type) {
      // console.log(type)
    },
    //放大
    enlargeFn() {
      this.$refs.viewer.zoomIncrease();
    },
    //缩小
    narrowFn() {
      this.$refs.viewer.zoomDecrease();
    },
    /**
     * [getPageIndex 获取页码]
     *
     * @param   {[type]}  pageCount     [pageCount 总页码]
     * @param   {[type]}  currentIndex  [currentIndex 当前页码]
     *
     * @return  {[type]}                [return description]
     */
    getPageIndex(pageCount, currentIndex) {
      this.pageCount = pageCount;
      this.currentIndex = currentIndex + 1;
    },
    confirmPrinting() {
      if (this.uploadLists.find(item => item.percentage !== 100))
        return this.$alert({
          description: "请等待文件上传完成"
        });
      const printableLists = this.uploadLists.filter(
        ({ response }) =>
          response &&
          response.data &&
          response.data.printNo &&
          response.code === 0
      );
      this.SET_UPLOAD_LISTS(printableLists);
      // 全部上传完成后printable准确，可用于判断
      if (printableLists.length === 1) {
        // 单文件打印
        this.percentage = 0;
        this.previewDialog = true;
        this.currentFile = this.uploadLists.find(
          item =>
            item.response &&
            item.response.data &&
            item.response.data.printNo &&
            item.response.code === 0
        );
        const callback = downloadUrl => {
          if (this.previewDialog) {
            this.previewDialog = false;
            this.$emit("togglePrintOptions", this.currentStatus, downloadUrl);
          }
        };
        this.searchStatus(callback);
        this.fakePercentage();
      } else {
        this.$emit("togglePrintOptions");
      }
    }
  },
  created() {
    this._getPageIndex = this.utils.util.throttle(this.getPageIndex, 200); // 函数节流
  },
  beforeDestroy() {
    this.isClearTimer = true;
  }
};
</script>

<style scoped lang="scss">
@import "../../pages/web/index/index.scss";
.progress {
  width: 180px;
}
.emptyTemplate {
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    display: flex;
    flex-direction: column;
    color: #424242;
    font-size: 16px;
    span {
      margin: 18px 0 0 0;
    }
  }
}
.errorP {
  i {
    margin-right: 5px;
    color: #ff5353;
    font-size: 14px;
  }
  span {
    font-size: 14px;
    color: #666666;
  }
}

.optUl {
  display: flex;
  align-items: center;
  li {
    width: 25px;
    height: 25px;
    margin-right: 10px;
  }
  .itemLi {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 25px;
    height: 25px;
    border-radius: 2px;
    .del_img {
      width: 22px;
      height: 22px;
      background-image: url("~@/assets/img/printingPage/delete.png");
      background-size: 100% 100%;
    }
    .fileSearch_img {
      width: 18px;
      height: 18px;
      background-image: url("~@/assets/img/printingPage/fileSearch.png");
      background-size: 100% 100%;
    }
    &:hover {
      background-color: #f0f0f0;
      .del_img {
        background-image: url("~@/assets/img/printingPage/delete_on.png");
      }
      .fileSearch_img {
        background-image: url("~@/assets/img/printingPage/fileSearch_on.png");
      }
    }
  }
}

.modalIndex {
  z-index: 1045 !important;
}

.v-modal {
  z-index: 1040 !important;
}

::v-deep .el-dialog__wrapper {
  z-index: 1043 !important;
}

.uploadProgress {
  text-align: center;
  height: 195px;
  .fileName {
    line-height: 16px;
    height: 16px;
  }
  span {
    display: inline-block;
    color: #999999;
    font-size: 12px;
    margin: 24px 0 19px 0;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  p {
    color: #333333;
    font-size: 16px;
    margin-bottom: 22px;
  }
}
.icon {
  width: 56px;
  height: 56px;
  margin: 0 auto;
  background-color: $theme-color;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    font-size: 56px;
    color: #ff5353;
  }
}
.uploadProgress .dialogFooter {
  margin: 0;
  button {
    padding: 0px 20px;
    height: 32px;
  }
}
.previewDialog {
  >>> .el-dialog__header {
    border-bottom: 1px solid #eeeeee;
  }
}

.previewBox {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  .editFrame {
    width: 360px;
    height: 500px;
    border: 1px solid #ddd;
    position: relative;
  }
  .pagination {
    color: #666666;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    width: 100%;
    text-align: center;
    position: relative;
    .functionBar {
      position: absolute;
      top: 0;
      right: 0;
      height: 40px;
      display: flex;
      align-items: center;
      .enlarge {
        cursor: pointer;
        display: block;
        background-size: 100% 100%;
        background: url("~@/assets/img/deviceManagement/enlarge.png") no-repeat
          center;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        border-radius: 10px;
        &:hover {
          background: url("~@/assets/img/deviceManagement/enlarge_h.png")
            no-repeat center;
        }
      }
      .narrow {
        display: block;
        cursor: pointer;
        background-size: 100% 100%;
        background: url("~@/assets/img/deviceManagement/narrow.png") no-repeat
          center;
        width: 20px;
        height: 20px;
        border-radius: 10px;
        &:hover {
          background: url("~@/assets/img/deviceManagement/narrow_h.png")
            no-repeat center;
        }
      }
    }
  }
}
.closePreviewDialog {
  margin-top: 19px;
  width: 115px;
  height: 48px;
  text-align: center;
  color: white;
  line-height: 48px;
  background-color: $theme-color;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  &:hover {
    background-color: $theme-color-hover;
  }
}

.btnBox {
  display: flex;
  margin: 20px 0;
  .printBtn {
    width: 115px;
    height: 48px;
    text-align: center;
    color: white;
    line-height: 48px;
    background-color: $theme-color;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    margin-right: 20px;
    &:hover {
      background-color: $theme-color-hover;
    }
  }
  .printBtn.disabled {
    background-color: #dddddd;
  }
  .cancelBtn {
    width: 115px;
    height: 48px;
    text-align: center;
    color: #999999;
    line-height: 48px;
    border: 1px solid #dddddd;
    background-color: white;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      color: $theme-color;
      border-color: $theme-color;
    }
  }
}
</style>

<style lang="scss">
.optPopover {
  padding: 12px 10px !important;
  min-width: 0 !important;
  width: auto;
  text-align: center;
  background-color: rgba($color: #424242, $alpha: 0.9);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  color: white;
  border: 0;
  .popper__arrow {
    border: 0;
    &::after {
      border-color: transparent;
      border-top-color: #424242 !important;
    }
  }
}
.upload_table {
  tbody {
    .cell {
      padding-left: 10px !important;
    }
  }
}
</style>
